import { COMPANY_DELETION_SCHEDULE_STATUS, LicenseTerminationTiming } from '@/types/types';

export const licenseActionLabel = (timing?: LicenseTerminationTiming | null) => {
    switch (timing) {
        case 'Immediately':
            return 'Ended immediately';
        case 'AtSubscriptionBillingPeriodEnd':
            return 'End at the end of the billing period';
        case 'AtBindingPeriodEnd':
            return 'End at the end of the binding period';
        default:
            return 'Left as they are';
    }
};

export const statusLabel = (status: number) => {
    switch (status) {
        case COMPANY_DELETION_SCHEDULE_STATUS.Scheduled:
            return { label: 'Scheduled', color: 'orange.4' };
        case COMPANY_DELETION_SCHEDULE_STATUS.Cancelled:
            return { label: 'Cancelled', color: 'muted' };
        case COMPANY_DELETION_SCHEDULE_STATUS.Deleted:
            return { label: 'Deleted', color: 'green.5' };
        case COMPANY_DELETION_SCHEDULE_STATUS.Failed:
            return { label: 'Failed', color: 'danger' };
        default:
            return { label: `Status ${status}`, color: 'muted' };
    }
};

export const sourceLabel = (sourceName: string) => {
    switch (sourceName) {
        case 'Manual':
            return 'Manual delete';
        case 'Scheduled':
            return 'Marked for deletion';
        case 'InactiveSweep':
            return 'Inactive sweep';
        default:
            return sourceName;
    }
};
